module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter03"
    }
  }), _vm._v("3")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WHEN JEREMIAH FINALLY MADE IT TO HIS PICKUP HE FOUND HIS WIFE ON")]), _vm._v(" the passenger side, sitting with one hand on the door frame as if holding herself in. As if the feel of the door frame against her fingertips were the only thing keeping her from imploding.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah’s concern for her was such that he tested the speed limit on the way home. Directly he was turning off Highway 36 onto the county road and roaring up it in a great eruption of caliche dust. Martha sat as before, with her eyes closed and one hand resting on the door frame.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He pulled around back of their little ranch house and skidded to a halt. He leapt from the cab and hustled around to Martha’s side. Helped her down and led her by the arm to the back gate, where they were greeted by Jake, their black Lab. The dog leapt about and sniffed Jeremiah’s pants cuffs while he guided his wife through the back door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Once inside the bedroom she sat on the bed and kicked off her pumps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You need any help?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She held up one hand and shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ll be back to check on you directly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah proceeded into the kitchen, where he set coffee to dripping. He leaned against the counter with his arms crossed over his chest and listened to the coffeemaker.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He considered the man mirrored in the kitchen window. Blue-eyed, khaki clad, hair more salt than pepper by the day. Solid of jaw. Skin coppered from pursuing his livelihood under the Texas sun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His career in law enforcement, his nearly thirty years of keeping the peace first in the highway patrol and then as a Texas Ranger, seemed that of another man anymore. About all he had left to show for it was a drawer full of keepsakes and a pension check.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His life had shrunk to a couple hundred dusty acres on which he "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("kept cattle, three horses, a small vegetable patch that was mostly his wife’s doing, and a stock tank from which he would pull the occasional fish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Retirement was, in his view, overrated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He hauled himself upright and returned to the bedroom, where he found Martha already tucked in with eyes closed. The light still burned in the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He sat on the edge of the bed and brushed the gray curls out of his wife’s face. She had been a beauty in her day, and traces of that beauty yet remained. Ever since she quit drinking a playful light had returned to her eyes. “You gon’ be okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Feels like squirrels are chasing around in my stomach,” she said with eyes closed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He leaned down and kissed her forehead. “You get some sleep. See if you don’t feel better come mornin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He hit the light switch and gently pulled the door to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Back in the kitchen he helped himself to a cup of black and fetched a ranching magazine off the countertop. He took a seat in the family room and commenced to read.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His reading was interrupted by the sound of a door closing. He rose and walked to the bedroom and eased the door open a fraction. The bed was empty and the sheets thrown back. A strip of light shone under the bathroom door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah crossed the room and stood at the door listening. “Martha?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("No response.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He knocked softly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Gimme a minute.” Her voice sounded strained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To stand at the door listening felt like voyeurism. He took a seat at the foot of the bed with his hands resting palm down on his thighs and considered the possibilities. After what seemed a long time he heard the toilet flush and water running in the sink. The strip of light at floor level winked out, and the door swung open. Martha shuffled out with her shoulders slumped. She looked all but shapeless, as though formed from plastic extruded into a lumpy and asymmetric mold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah helped her back to bed. “You gon’ be okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She sighed. “Having been through that episode, I’d like to think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But her distress continued on, and when it became evident that she couldn’t stop and further owned up to losing a disturbing quantity of "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("blood Jeremiah helped her into her clothes and then walked her to his truck, where he seated her on the passenger side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He climbed in behind the wheel and keyed the engine to life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("They drove through the night to the county hospital at speeds greater than what made good sense in a high-carriage vehicle.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a4fb5e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter03.vue
// module id = 90
// module chunks = 0